import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

// ✅ GET ALL BANNERS (/banner/)
export const getBanners = createAsyncThunk(
  "banner/getBanners",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/banner/", {
        params: params?.title ? { title: params.title } : undefined,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to fetch banners",
      );
    }
  },
);

// ✅ GET BANNER BY ID (/banner/${id}/)
export const getBannerById = createAsyncThunk(
  "banner/getBannerById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/banner/${id}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to fetch banner details",
      );
    }
  },
);

// ✅ CREATE BANNER (/banner/) [POST]
export const createBanner = createAsyncThunk(
  "banner/createBanner",
  async (payload, { rejectWithValue }) => {
    try {
      const isFormData = payload instanceof FormData;
      const response = await axiosInstance.post(`/banner/`, payload, {
        headers: isFormData
          ? { "Content-Type": "multipart/form-data" }
          : { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.errors ||
          error.response?.data?.message ||
          error.response?.data?.status ||
          "Failed to create banner",
      );
    }
  },
);

// ✅ UPDATE BANNER (/banner/${id}/) [PATCH]
export const updateBanner = createAsyncThunk(
  "banner/updateBanner",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const isFormData = data instanceof FormData;
      const response = await axiosInstance.patch(`/banner/${id}/`, data, {
        headers: isFormData
          ? { "Content-Type": "multipart/form-data" }
          : { "Content-Type": "application/json" },
      });
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.errors ||
          error.response?.data?.Errors ||
          error.response?.data?.message ||
          "Failed to update banner!",
      );
    }
  },
);

// ✅ DELETE BANNER (/banner/${id}/) [DELETE]
export const deleteBanner = createAsyncThunk(
  "banner/deleteBanner",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/banner/${id}/`);
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete banner!",
      );
    }
  },
);

